import SEO from "../components/SEO";
import EventsSection from "../components/Events";

export default function Events() {
  return (
    <>
      <SEO
        title="Events | Jisedai"
        description="Explore upcoming Jisedai events, workshops, bootcamps, and community learning experiences."
        url="https://www.jisedai.africa/events"
      />
      <EventsSection />
    </>
  );
}
